module.exports = __webpack_public_path__ + "img/ball.7c07829d.png";